import { Outlet, useParams } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import { navSettingWorkspace } from '@/components/layout/navigation/configNav';
import { RouteParams } from '../type';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';

const WorkspaceSettingLayout = () => {
  const { workspaceId } = useParamWorkspaceId();
  const navbarConfig = useMemo(
    () => ({
      title: 'Setting',
      navbar: navSettingWorkspace(workspaceId),
    }),
    [workspaceId]
  );
  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });
  return (
    <div className="pt-10">
      <Outlet />
    </div>
  );
};

export default WorkspaceSettingLayout;
